var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0 reversed", attrs: { fluid: "" } },
    [
      _c(
        "v-window",
        {
          model: {
            value: _vm.windowIndex,
            callback: function($$v) {
              _vm.windowIndex = $$v
            },
            expression: "windowIndex"
          }
        },
        [
          _c(
            "v-window-item",
            { attrs: { value: 1 } },
            [
              _c(
                "v-container",
                { staticClass: "DashboardBox", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "borderbox d-flex justify-space-between elevation-1 pa-3 align-center"
                          },
                          [
                            _c("div", { staticClass: "d-flex align-center" }, [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: {
                                  src: require("@/assets/iconFile.svg"),
                                  width: "35px",
                                  height: "35px"
                                }
                              }),
                              _c("p", { staticClass: "textpCustom title" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      this.title ? this.title : "Facturación"
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "py-3" },
                    [_c("FileManagement", { attrs: { title: "Facturación" } })],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }